const separatorStyle = `
  left: 0;
  right: 0;
  content: '';
  position: absolute;
  background-color: #DBDBDB;
  height: 0.5px;
  min-height: 0.5px;
  @-moz-document url-prefix() {
    height: 1px;
    min-height: 1px;
  }`;

export const theme = {
  colors: {
    basic00: '#0D1B2A',
    basic01: '#293347',
    basic02: '#415A77',
    basic03: '#778DA9',
    basic04: '#BEC1BC',
    basic05: '#E0E1DD',
    basic06: '#EEEEEC',
    basic07: '#F5F5F4',
    basic08: '#FFFFFF',
    accent00: '#3772FF',
    accent01: '#145AFF',
    accent02: '#EEF2FC',
    manual00: '#3DD3F5',
    auto00: '#40DD6F',
    signalOrange00: '#FEA82F',
    signalOrange01: '#FFF2E1',
    signalRed00: '#DF2935',
    signalRed01: '#FADCDD',
    signalGreen00: '#3DA35D',
    signalGreen01: '#D2EEDB',
  },
  fonts: {
    robotoMono: 'Roboto Mono',
    inter: 'Inter',
  },
  roundedSmall: '3px',
  roundedMedium: '6px',
  roundedBig: '12px',
  flexColumn: `display: flex;
                flex-direction: column;`,
  flexSpaceBetween: `display: flex;
                     justify-content: space-between;`,
  flexAlignItemsCenter: `display: flex;
                          align-items: center;`,
  flexCenter: `display: flex;
               align-items: center;
               justify-content: center;`,
  topSeparator: `
  position: relative;
    :before {
      top: 0;
      ${separatorStyle}
    }
  `,
  bottomSeparator: `
  position: relative;
    :before {
      bottom: 0;
      ${separatorStyle}
    }
  `,
};

export const fontStyles = {
  headline: `
    font-family: ${theme.fonts.inter};
    font-style: normal;
    font-weight: 300;
    font-size: 23px;
    line-height: 32px;
    color: ${theme.colors.basic00};
  `,
  titleR: `
    font-family: ${theme.fonts.inter};
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;
    color: ${theme.colors.basic00};
  `,
  subtitleR: `
    font-family: ${theme.fonts.inter};
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: ${theme.colors.basic00};
  `,
  captionB: `
    font-family: ${theme.fonts.inter};
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 24px;
    color: ${theme.colors.basic00};
  `,
  bodyNum: `
    font-family: ${theme.fonts.robotoMono};
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
    color: ${theme.colors.basic00};
  `,
  bodyM: `
    font-family: ${theme.fonts.inter};
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
    color: ${theme.colors.basic00};
  `,
  bodyR: `
    font-family: ${theme.fonts.inter};
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: ${theme.colors.basic00};
  `,
  tinyNum: `
    font-family: ${theme.fonts.robotoMono};
    font-style: normal;
    font-weight: 700;
    font-size: 11px;
    line-height: 16px;
    color: ${theme.colors.basic00};
  `,
  tinyM: `
    font-family: ${theme.fonts.inter};
    font-style: normal;
    font-weight: 500;
    font-size: 11px;
    line-height: 16px;
    color: ${theme.colors.basic00};
  `,
  tinyR: `
    font-family: ${theme.fonts.inter};
    font-style: normal;
    font-weight: 400;
    font-size: 11px;
    line-height: 16px;
    color: ${theme.colors.basic00};
  `,
};

export type ThemeT = typeof theme;
